import { TableColumn, TableConfig } from 'src/app/@shared/models/table.models';

export const INVOICE_TABLE_COLUMNS: TableColumn[] = [
    {
        field: 'date',
        header: 'Date',
        type: 'custom',
        template: 'dateCellRef',
        width: '20%',
        sortable: true,
    },
    {
        field: 'type',
        header: 'Payment Type',
        type: 'custom',
        template: 'typeCellRef',
        width: '20%',
    },
    {
        field: 'total',
        header: 'Total',
        type: 'custom',
        template: 'totalCellRef',
        width: '20%',
        sortable: true,
    },
    {
        field: 'status',
        header: 'Status',
        type: 'custom',
        template: 'statusCellRef',
        width: '20%',
    },
    {
        field: 'action',
        header: 'Actions',
        type: 'custom',
        template: 'actionCellRef',
        width: '20%',
    },
];

export const INVOICE_TABLE_CONFIG: TableConfig = {
    selectable: false,
    paginator: true,
    rows: 10,
    rowsPerPageOptions: [5, 10, 25, 50],
    loading: false,
    emptyMessage: 'No invoices found',
    globalFilter: false,
    responsive: true,
};
